import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { BaseContext } from 'context/base.context';
import { RoutePath } from 'routes/route-path.constant';

import { useSaveAnswers } from 'hooks/use-save-answers.hook';
import { useLocalStorage } from 'hooks/use-local-storage.hook';

import { LocalStorageKeys } from 'constants/local-storage';
import { TypographyVariants } from 'constants/typography-variants';

import { Typography } from 'components/typography';
import { ChoiceButton, ChoiceType } from 'components/choice-button';

export const BloodType = () => {
    const { t } = useTranslation();
    const saveAnswers = useSaveAnswers();

    const pageKey = LocalStorageKeys[RoutePath.BloodType];

    const { pageValue, setPageValue }: any = useLocalStorage({
        key: pageKey,
        defaultValue: '',
    });

    const { pageConfiguration } = useContext(BaseContext);

    const answers: ChoiceType[] = [
        {
            key: 'type-o',
            value: t('blood-type-option-type-o'),
        },
        {
            key: 'type-a',
            value: t('blood-type-option-type-a'),
        },
        {
            key: 'type-b',
            value: t('blood-type-option-type-b'),
        },
        {
            key: 'type-ab',
            value: t('blood-type-option-type-ab'),
        },
        {
            key: 'do-not-know',
            value: t('blood-type-option-type-do-not-know'),
        },
    ];

    const handleClick = (answer: ChoiceType) => {
        setPageValue(answer.key);

        saveAnswers({
            key: pageKey,
            itemQuestion: { question: t('blood-type-title'), value: t(answer.value) },
        });

        pageConfiguration.handleOnPageComplete(answer.key);
    };

    return (
        <>
            <Typography variant={TypographyVariants.h1} typographyNext>
                {t('blood-type-title')}
            </Typography>

            <Typography variant={TypographyVariants.h2}>
                {t('blood-type-subtitle')}
            </Typography>

            {answers.map((v: ChoiceType) => (
                <ChoiceButton
                    key={v.key}
                    center={true}
                    selected={v.key === pageValue}
                    typographyText={v.value}
                    onClick={() => handleClick(v)}
                />
            ))}
        </>
    );
};
